
import { useLocation,Navigate,Outlet, } from "react-router"; 
import { useEffect,useState } from "react";
import useRefreshToken from "../../Hooks/useRefreshToken";



// import useAuth from "../../Hooks/UseAuth"; 
// import useAuth from "../../Hooks/useAuth";
// import useAuth from "../../Hooks/useAuth";
import useAuth from "../../Hooks/UseAuth"
// import { useLocation } from "react-router";

const RequireAuth = ({allowedRoles}) =>{ 

     const {auth} = useAuth(); 
     const location = useLocation(); 
     console.log("auth",auth)
     const refresh = useRefreshToken();
     const [isLoading, setIsLoading] = useState(true);
     useEffect(() => {
          // let isMounted = true;
  
          const verifyRefreshToken = async () => {

               console.log("in require auth")
              try {
                  await refresh();
              }
              catch (err) {
                  console.error(err);
              }
              finally {
               //    isMounted && setIsLoading(false);
              }
          }
  
          // persist added here AFTER tutorial video
          // Avoids unwanted call to verifyRefreshToken
          !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);
          // !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);
  
          // return () => isMounted = false;
      // }, [])
      }, [])
     return( 
        auth?.roles?.find(role => allowedRoles?.includes(role))
        ? <Outlet />
        : auth?.user
            ? <Navigate to="/unauth" state={{ from: location }} replace />
            : <Navigate to="/" state={{ from: location }} replace />
     );

}

export default RequireAuth; 

// auth?.roles.find(role => allowedRoles?.includes(role)) 
// ? <Outlet />
//  : auth?.user
//  ?<Navigate to="/unauth" state ={{from : location}} replace />
//  :<Navigate to =  "/unauth" state ={{from : location}} replace />


///
// auth?.user 
// ? <Outlet /> : <Navigate to =  "/" state ={{from : location}} replace />